//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  methods:{
    cellClick(p1, p2){
      console.log(p1)
      console.log(p2)
    }
  }
}



// WEBPACK FOOTER //
// ./example/pages/cell.vue